export default __webpack_public_path__ + "static/media/login-2.98c634c8.svg";